export { default } from './Table';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/Table/index.js
// module id = 598
// module chunks = 121